import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import {
    EventModel,
    EventScoreboard,
    PairGameScore,
    PairGameScoreboardViewModel,
    getPairGameScore,
} from '@frontend/sports/betting-offer/feature/model';
import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';

import { EventTimerComponent } from '../../timers/event-timer.component';
import { PairGameParticipantComponent } from './pair-game-participant.component';
import { PenaltyShootoutComponent } from './penalty-shootout/penalty-shootout.component';
import { ScoreCardComponent } from './score-card.component';

@Component({
    selector: 'ms-pair-game-scoreboard',
    templateUrl: 'pair-game-scoreboard.component.html',
    imports: [
        NgClass,
        NgIf,
        NgFor,
        NgTemplateOutlet,
        EventTimerComponent,
        ScoreCardComponent,
        PairGameParticipantComponent,
        PenaltyShootoutComponent,
    ],
})
export class PairGameScoreboardComponent implements OnChanges {
    constructor(public sitecoreEventDetails: SitecoreEventDetailsConfig) {}

    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() showLogoColor: boolean;
    @Input() isNewEDPScoreboard = false;

    @HostBinding('class') className = 'pair-game';
    @HostBinding('class.show-penaltyshootout-score') showPenaltyShootoutScore = false;

    vm: PairGameScoreboardViewModel = {
        showPenalties: false,
        penalties: [],
        score: new PairGameScore(),
    };

    ngOnChanges(changes: ISimpleChanges<PairGameScoreboardComponent>): void {
        if (changes.scoreboard) {
            this.vm = getPairGameScore(this.event, this.isNewEDPScoreboard);
            this.showPenaltyShootoutScore = this.vm.showPenalties;
        }
    }
}
